import { injectable, interfaces } from 'inversify';
import { action, IObservableArray, makeObservable, observable } from 'mobx';
import { IRejectionReason } from './models/rejectionReason';

export interface IReviewRejectReasonsStore {
  readonly rejectionReasons: IObservableArray<IRejectionReason>;
  setRejectionReasons(rejectionReasons: IRejectionReason[]): void;
}

export namespace IReviewRejectReasonsStore {
  export const $: interfaces.ServiceIdentifier<IReviewRejectReasonsStore> = Symbol('ANNOTATION_REVIEW_STORE');
}

@injectable()
export class ReviewRejectReasonsStore implements IReviewRejectReasonsStore {
  rejectionReasons: IObservableArray<IRejectionReason> = observable.array([]);

  constructor() {
    makeObservable(this, {
      rejectionReasons: observable,
      setRejectionReasons: action,
    });
  }

  setRejectionReasons(rejectionReasons: IRejectionReason[]): void {
    this.rejectionReasons.replace(rejectionReasons);
  }
}
